<template>
    <div class="csv-export-component">
        <div class="panel panel-stretch">
            <div class="panel-heading"></div>
            <div class="panel-body">
                <a-steps progressDot :current="currentStep">
                    <a-step title="Velden" description="Velden selecteren"/>
                    <a-step title="Verifieer" description="Verifieer te exporteren velden"/>
                    <a-step title="Genereren" description="Export genereren"/>
                    <a-step title="Klaar" description="Document downloaden"/>
                </a-steps>
            </div>
            <div class="panel-body" v-show="currentStep === 0">
                <SelectionComponent :source-class="sourceClass"
                                    :default-definition-name="'Klant'"
                                    :default-values="values"
                                    @submit="onSelectedTemplateValues"></SelectionComponent>
            </div>
            <div class="panel-body" v-show="currentStep === 1">
                <p>
                    Het geexporteerde document zal er als volgt uit komen te zien:
                </p>
            </div>
            <div class="panel-body" v-show="currentStep === 1" style="overflow-y: auto;">
                <table class="table table-bordered">
                    <tbody>
                    <tr>
                        <th v-for="(value, index) in values" :key="index">
                            {{ value.key }}
                        </th>
                    </tr>
                    <tr>
                        <td v-for="(value, index) in values" :key="index">
                            {{ value.name }}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="panel-body" v-show="currentStep === 1">
                <a-button @click="edit" type="primary" ghost>Wijzigen velden</a-button>
                <a-button @click="startExport" type="primary">Start export</a-button>
            </div>
            <div class="panel-body" v-show="currentStep === 2">
                <div v-show="exportStatus === 1">
                    <div style="font-size: 20px;margin: 4rem;">
                        <a-icon type="loading"/>
                        Export wordt gestart
                    </div>
                </div>
                <div v-show="exportStatus === 2">
                    <div style="font-size: 20px;margin: 4rem;">
                        <p>Aan het exporteren</p>
                        <a-progress :percent="percentageDone" status="active"/>
                    </div>
                </div>
            </div>
            <div class="panel-body" v-show="currentStep === 3">
                <div style="margin: 4rem;">
                    <p style="font-size: 20px;">
                        Export voltooid, het document wordt gedownload.
                    </p>
                    Wordt het document niet automatisch gedownload, klik dan
                    <a-button type="primary" @click="downloadFile">hier</a-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import searchApi from '~/api/search';
// import store from '../store';
import SelectionComponent from "~/modules/templating/components/SelectionComponent";

export default {
  name: "SearchCSVExportComponent",
  props: ['sourceClass', 'definition', 'search'],
  data() {
    return {
      values: [],
      exportStatus: 0,
      percentageDone: 0,
      exportHash: null
    }
  },
  computed: {
    ...mapGetters({
      selectedDefinition: '$_templating/selectedDefinition',
    }),
    currentStep() {
      if (this.values.length > 0 && this.exportStatus === 0) {
        return 1;
      } else if (this.exportStatus === 0) {
        return 0;
      } else if (this.exportStatus === 1 || this.exportStatus === 2) {
        return 2;
      } else if (this.exportStatus === 3) {
        return 3;
      }
    }
  },
  created() {
    // const STORE_KEY = '$_templating';
    // // eslint-disable-next-line no-underscore-dangle
    // if (!(STORE_KEY in this.$store._modules.root._children)) {
    //     this.$store.registerModule(STORE_KEY, store);
    // }
  },
  mounted() {
    this.initializePusher();
  },
  components: {
    SelectionComponent
  },
  methods: {
    initializePusher() {

      let channel = this.$pusher.subscribe('private-tenant.' + window.state.tenant.hash_id + '.search');

      channel.bind('export_progress', (progress) => {
        if (progress.hash === this.exportHash) {
          this.percentageDone = progress.progress;
          this.exportStatus = 2;
        }
      });

    },
    edit() {
      this.values = [];
      Vue.$refs.selectionComponent.edit();
    },
    onSelectedTemplateValues(templateValues) {
      this.values = templateValues;
    },
    startExport() {
      let mappedValues = this.values.map(function (value) {
        return value.key;
      });


      this.interval = setInterval(this.checkIfExportIdDone, 1000);

      searchApi.exportSearchToCSV(this.search.model, JSON.stringify(this.search.content), mappedValues).then((data) => {
        this.exportHash = data.id;
        this.exportStatus = 1;
      }).catch(function (error) {
        this.$message.error('Er ging iets fout tijdens het starten van de CSV export.');
        this.exportStatus = 0;
      });
    },
    checkIfExportIdDone() {
      $.get('/export/' + this.exportHash + '/status', function (json) {
        window.clearInterval(this.interval);
        this.percentageDone = 100;
        this.exportStatus = 3;
        this.downloadFile(this.exportHash);
      }.bind(this))
    },
    downloadFile() {
      let win = window.open('/export/' + this.exportHash + '/download', '_blank');
      window.focus();
    }
  }
}
</script>

<style scoped>
.csv-export-component {
}

table.table th, table.table td {
    padding: 1.5rem 1rem;
}
</style>